export default "__VITE_ASSET__681b6b2c__ 600w, __VITE_ASSET__3812d29d__ 960w, __VITE_ASSET__59a20458__ 1280w, __VITE_ASSET__0498a8c0__ 1920w";